import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { GetPersonDisplayName } from '../Persons.Functions';
import { PhoneViewModel } from '../../../models/Entities/Person/Phone/PhoneModels';

// store
import * as PersonPhonesStore from '../../../redux/middleware/PersonPhones.Middleware';

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  PersonId: number;
  phoneId?: number | undefined;
}

interface ConnectedProps {
  personName: string;
  isAdding: boolean | undefined;
  successAdding: boolean | undefined;
  failAdding: boolean | undefined;
  isUpdating: boolean | undefined;
  successUpdating: boolean | undefined;
  failUpdating: boolean | undefined;
  error: ErrorType | undefined;
  phone?: PhoneViewModel;
}

interface DispatchProps {
  CreatePhone: typeof PersonPhonesStore.actionCreators.CreatePhone;
  UpdatePhone: typeof PersonPhonesStore.actionCreators.UpdatePhone;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  personName: GetPersonDisplayName(state.Persons?.list.find((person) => person.id === ownProps.PersonId)),
  isAdding: state.PersonPhones?.isAddingNewOne,
  successAdding: state.PersonPhones?.successAddingNewOne,
  failAdding: state.PersonPhones?.failOnAddingNewOne,
  isUpdating: state.PersonPhones?.isUpdatingOne,
  successUpdating: state.PersonPhones?.successUpdatingOne,
  failUpdating: state.PersonPhones?.failOnUpdatingOne,
  error: state.PersonPhones?.error,
  phone: state.PersonPhones?.list.find((item: PhoneViewModel) => item.id === ownProps.phoneId),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonPhonesStore.actionCreators
};
